import { Box, Chip, Divider, Link, Stack, Typography, useTheme } from '@mui/material'
import { useSelector } from 'react-redux'
import { Link as RouterLink } from 'react-router'
import {
  UIStatus,
  WaterQualityIndexSelectors,
} from '../../../../store/waterQualityIndex'

const CHIP_STYLES: Record<UIStatus, { label: string; sx: Record<string, string> }> = {
  unsafe: {
    label: 'Unsafe',
    sx: { color: 'error.main', borderColor: 'error.main', bgcolor: 'error.light' },
  },
  cautious: {
    label: 'Cautious',
    sx: { color: 'warning.dark', borderColor: 'warning.main', bgcolor: 'warning.light' },
  },
  safe: {
    label: 'Safe',
    sx: { color: 'success.dark', borderColor: 'success.main', bgcolor: 'success.light' },
  },
}

export const SignalsCard = () => {
  const theme = useTheme()
  const groups = useSelector(WaterQualityIndexSelectors.selectSignalGroupsWithStatus)

  const dotColor = (status: UIStatus) => {
    switch (status) {
      case 'unsafe':
        return theme.palette.error.main
      case 'cautious':
        return theme.palette.warning.main
      default:
        return theme.palette.success.main
    }
  }

  return (
    <Box
      sx={{
        p: 2.5,
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper',
        height: '100%',
      }}
    >
      <Typography variant="overline" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
        SIGNAL GROUPS
      </Typography>
      {groups.length === 0 && (
        <Typography variant="body2" color="text.disabled" sx={{ py: 1 }}>
          No signal groups to show yet.
        </Typography>
      )}
      {/* SIPP-836: per-row "View →" links removed in favour of a single
          card-level link below — they routed to the wrong tab and made the
          card busy. */}
      {groups.map((group, idx) => {
        const chip = CHIP_STYLES[group.status]
        return (
          <Box key={group.groupName}>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              py={1}
            >
              <Stack direction="row" spacing={1} alignItems="center">
                <Box
                  sx={{
                    width: 8,
                    height: 8,
                    borderRadius: '50%',
                    bgcolor: dotColor(group.status),
                    flexShrink: 0,
                  }}
                />
                <Typography variant="body2" fontWeight={600}>
                  {group.groupName}
                </Typography>
              </Stack>
              <Chip
                variant="outlined"
                size="small"
                label={chip.label}
                sx={chip.sx}
              />
            </Stack>
            {idx < groups.length - 1 && <Divider />}
          </Box>
        )
      })}
      <Box sx={{ mt: 1.5 }}>
        <Link
          component={RouterLink}
          to="/profile/insights"
          variant="caption"
          sx={{ color: 'primary.dark', textDecoration: 'none', fontWeight: 600 }}
        >
          View signals →
        </Link>
      </Box>
    </Box>
  )
}
